import { FC } from "react";

const DropdownPossibleNextStep: FC = (): JSX.Element => {
  return (
    <li className="nav-item dropdown">
      <button className="btn-link nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
          <span className="d-lg-none d-xl-inline-block">Possible</span> "Next Steps"
      </button>

      <ul className="colors-dropdown dropdown-menu dropdown-menu-end px-4 py-3">
        <p className="p-2"  aria-expanded="false">
        On the case screen, you can see a new column labeled "Next Steps". These new options allow you to update your cases without the need to contact FUROSCIX Direct. The actions available are as follows:
        </p>
        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <div className="row">
            <div className="col-sm-6">
              <button className="btn bg-yellow-light my-1 text-white">
                <i className="fas fa-clipboard-list"></i> Prior Authorization
              </button>
            </div>
            <div className="col-sm-6">
            Clicking "Prior Authorization" allows you to upload clinicals and enter information for the precert as well as submit it to the plan or request it be completed on your behalf.
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <div className="row">
            <div className="col-sm-6 ml-3 pl-3">
              <span className="btn btn-success my-1 text-white">
                <i className="fas fa-prescription"></i> Order
              </span>
            </div>
            <div className="col-sm-6">
            Clicking "Order" Allows for the ordering of FUROSCIX.
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <div className="row">
            <div className="col-sm-6">
              <span className="btn bg-danger my-1 text-white">
                <i className="fas fa-times"></i> Cancelled
              </span>
            </div>
            <div className="col-sm-6">
            Clicking "Cancelled" Indicates that you do not intend to treat the patient with FUROSCIX, and allows for the input of a reason.
            </div>
          </div>
        </li>
      </ul>
    </li>
  );
};

export default DropdownPossibleNextStep;
